import { Injectable } from '@angular/core';
import { CatalogApiResponse, Membership } from '@app/shared/models/api-response/catalog-api-response';
@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  	constructor() {
  	}

  	getCategoryLayout(outlet: any): string {
        if ('memberships' in outlet) {
            const membership = outlet.memberships.filter((membership: any) => membership.id === outlet.brand_id);
            if (membership.length) {
            	return membership[0].category_layout;
            }
        }

        if ('membership' in outlet) {
        	return outlet.membership.category_layout;
        }
    }

    getProductLayout(outlet: any): string {
        if ('memberships' in outlet) {
            const membership = outlet.memberships.filter((membership: any) => membership.id === outlet.brand_id);
            if (membership.length) {
            	return membership[0].product_card_layout;
            }
        }

        if ('membership' in outlet) {
        	return outlet.membership.product_card_layout;
        }
    }

    getMembership(outlet: CatalogApiResponse['outlet']): Membership {

        if (!outlet) {
            return;
        }

        if ('memberships' in outlet) {
            const membership = outlet.memberships.filter((membership) => membership.id === outlet.brand_id);
            if (membership.length) {
                return membership[0];
            }
        }

        if ('membership' in outlet) {
            return outlet.membership;
        }
    }

    getBrandName(outlet: any) {
        const membership = this.getMembership(outlet);
        return membership ? membership.label : '';
    }
}
